import React from 'react'

const Button = ({className, children, onClick}:any) => {
  return (
    <div onClick={onClick} className={`bg-primary ${className} px-6 py-3 rounded-lg  shadow-md w-fit text-black font-semibold  transition-all ease-in-out cursor-pointer`}>
        {children}
    </div>
  )
}

export default Button